import { Modal as RenderbusModal } from "@renderbus/ui";
import { PropsWithChildren } from "react";
import { ModalProps } from "antd";
import { RenderbusModalProps } from "@renderbus/ui/components/modal";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
const t = getTranslateNsT("center");

export function Modal({
  okText = t("common_store_global_dialog_default_okey"),
  cancelText = t("common_store_global_dialog_default_cancel"),
  ...props
}: PropsWithChildren<ModalProps & RenderbusModalProps>) {
  return <RenderbusModal okText={okText} cancelText={cancelText} {...props} />;
}

Modal.confirm = RenderbusModal.confirm;
